(function () {
    "use strict";

    /********************************************************************************************************/
    /**** @CC This is the default direct to customer behaviour                                           ****/
    /********************************************************************************************************/

    cip_Entity.clientHomePageUrl = "https://www.regionalaustraliabank.com.au";
    cip_Entity.previousSelectedPageId = null;
    cip_Entity.hasSubmitted = false;

    cip_Entity.createNextButtonText = function (entityName, formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad) {
        var text = null;

        if (isInterviewComplete == false) {
            if (isLastNonRestrictedPageSelected == true && isReadyToFinish == true) {
                text = 'Submit';
            } else {
                text = 'Next';
            }
        } else {
            text = 'Next';
        }

        return text;
    };

    cip_Entity.createPreviousButtonText = function(entityName, formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad){
        var text = null;

        if(isFirstPageSelected == false){
            text = 'Previous';
        }

        if (text !== null && (formId == "personalcredit" || formId == "mortgage_cdr_merge")) {
            text = "Back";
        }

        return text;
    };

    cip_Entity.createSaveButtonText = function(entityName, formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad){

        if (formId == "personalcredit" || formId == "mortgage_cdr_merge") {
            return "Exit and Save";
        }
        return 'Continue Later';
    };

    cip_Entity.showApplicationSaveAsDialog = function (entityName, formId, application) {
        var saveAs = null;

        if (application.customers && application.customers.length > 0) {
            var primaryCustomer = application.customers[0];

            if (primaryCustomer.email && primaryCustomer.mobilePhoneNumber) {
                saveAs = {
                    email: primaryCustomer.email,
                    mobilePhoneNumber: primaryCustomer.mobilePhoneNumber
                };
            }
        }

        var saveUnsubmittedApplicationToCompleteLater = function (saveAs, sanitisedEmail) {
            cc_EntityIntegration.saveUnsubmittedApplicationToCompleteLater(cc_Config.applicationId, saveAs.email, saveAs.mobilePhoneNumber, function () {
                cc_UI.showNotificationDialog(
                    "Your application has been saved.<br><br>" +
                    "Instructions on how to continue this application have been sent to " + (sanitisedEmail ? sanitisedEmail : "your email address"),
                    "Application Saved", function () {
                        window.location.href = cip_Entity.clientHomePageUrl;
                    }, screen.width < cc_UI.viewportMinimumWidth ? screen.width : 450
                );
            });
        }

        if (saveAs) {
            cc_UI.showConfirmDialog('Would you like to save this application and continue later?', function () {
                saveUnsubmittedApplicationToCompleteLater(saveAs, saveAs.email); // email has been sanitised on the server
            }, null, 'Confirmation');

        } else {
            cc_UI.createSimpleDialog({
                id: cip_SaveAsDialog.id(),
                title: cip_SaveAsDialog.title(),
                content: cip_SaveAsDialog.content(),
                width: screen.width < cc_UI.viewportMinimumWidth ? screen.width : cip_SaveAsDialog.width(),
                okText: cip_SaveAsDialog.okText,
                firstOpen: function () {
                    if (application.customers && application.customers.length > 0) {
                        var primaryCustomer = application.customers[0];

                        cip_SaveAsDialog.populate({
                            email: primaryCustomer.email,
                            mobilePhoneNumber: primaryCustomer.mobilePhoneNumber
                        });
                    }
                },
                ok: function () {
                    var saveAs = cip_SaveAsDialog.unpopulate();

                    var validateSaveAs = function (saveAs) {
                        var email = saveAs.email;
                        var mobilePhoneNumber = saveAs.mobilePhoneNumber;

                        var errors = [];

                        // email address validator
                        if (email) {
                            var emailExpression = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                            if (emailExpression.test(email) == false) {
                                errors.push({description: 'a valid email address is required'});
                            }
                        } else {
                            errors.push({description: 'an email address is required'});
                        }

                        // mobile phone number validator
                        if (mobilePhoneNumber) {
                            var mobilePhoneExpression = /^04\d{8}$/;
                            mobilePhoneNumber = mobilePhoneNumber.replace(/ /g, '').replace('+61', '0');

                            if (mobilePhoneExpression.test(mobilePhoneNumber) == false) {
                                errors.push({description: 'a valid mobile phone number is required'});
                            }
                        } else {
                            errors.push({description: 'a mobile phone number is required'});
                        }

                        return errors;
                    };

                    var errors = validateSaveAs(saveAs);

                    if (errors.length === 0) {
                        saveUnsubmittedApplicationToCompleteLater(saveAs);
                    } else {
                        cc_UI.attachErrorsToDialog(cip_SaveAsDialog.id(), errors);
                    }
                }
            });
        }
    };

    cip_Entity.showSendSmsCodeDialog = function (entityName, formId, data, successCallback) {
        cc_UI.createSimpleDialog({
            id: cip_SendSmsCodeDialog.id(),
            title: cip_SendSmsCodeDialog.title(),
            content: cip_SendSmsCodeDialog.content(data),
            width: screen.width < cc_UI.viewportMinimumWidth ? screen.width : cip_SendSmsCodeDialog.width(),
            okText: cip_SendSmsCodeDialog.okText,
            closable: false,
            ok: function () {
                $("#" + cip_SendSmsCodeDialog.id()).dialog('close').hide();
                successCallback();
            }
        });
    };

    cip_Entity.showActivateUsingSmsCodeDialog = function (entityName, formId, data) {
        var resendButtonText = "Resend SMS Activation Code";

        cc_UI.createSimpleDialog({
            id: cip_ActivateUsingSmsCodeDialog.id(),
            title: cip_ActivateUsingSmsCodeDialog.title(),
            content: cip_ActivateUsingSmsCodeDialog.content(data),
            width: screen.width < cc_UI.viewportMinimumWidth ? screen.width : cip_ActivateUsingSmsCodeDialog.width(),
            okText: cip_ActivateUsingSmsCodeDialog.okText,
            closable: false,
            firstOpen: function () {
                $("button:contains(" + resendButtonText + ")").addClass("btn-default").removeClass("btn-primary");
            },
            ok: function () {
                var activateUsingSmsCode = cip_ActivateUsingSmsCodeDialog.unpopulate();

                cc_EntityIntegration.activateApplicantSessionUsingSmsCode(activateUsingSmsCode.smsCode);
            },
            additionalButtons: [{
                text: resendButtonText,
                action: function () {
                    cc_EntityIntegration.sendApplicantSessionActivationSmsCode(function () {
                        $("button:contains(" + resendButtonText + ")").hide(); // only allow one resend
                        cc_UI.showNotificationDialog("An activation code has been resent to your mobile phone.", "Sent SMS Activation Code");
                    });
                }
            }]
        });
    };

    cip_Entity.showActivateUsingCustomerDetailsDialog = function (entityName, formId, data) {
        cc_UI.createSimpleDialog({
            id: cip_ActivateUsingCustomerDetails.id(),
            title: cip_ActivateUsingCustomerDetails.title(),
            content: cip_ActivateUsingCustomerDetails.content(data),
            width: screen.width < cc_UI.viewportMinimumWidth ? screen.width : cip_ActivateUsingCustomerDetails.width(),
            okText: cip_ActivateUsingCustomerDetails.okText,
            closable: false,
            ok: function () {
                var customerDetails = cip_ActivateUsingCustomerDetails.unpopulate();

                cc_EntityIntegration.activateApplicantSessionUsingCustomerDetails(customerDetails.email, customerDetails.firstName, customerDetails.lastName, customerDetails.representativeName);
            }
        });
    };

    cip_Entity.handleUnavailableApplicantSession = function (entityName, formId) {
        cc_UI.createSimpleDialog({
            id: "unavailableApplicantSessionDialog",
            title: "Unauthorised Access",
            content: "",
            width: screen.width < cc_UI.viewportMinimumWidth ? screen.width : 450,
            closable: false,
            firstOpen: function () {
                cc_UI.attachErrorToDialog("unavailableApplicantSessionDialog",
                    "You are not allowed to access this page."
                );
            },
            ok: function () {
                window.location.href = cip_Entity.clientHomePageUrl;
            }
        });
    };

    cip_Entity.handleInvalidApplicantSmsCode = function (entityName, formId, data) {
        var message = null;
        if (data && data.tooManyFailedAttempts === 'true') {
            message = 'Too many failed attempts, please try again in a few minutes.';
        } else {
            message = 'You have entered an invalid activation code. Please check for any mistakes and try again.';
        }

        cc_UI.showErrorDialog(message, 'Invalid SMS Activation Code');
    };

    cip_Entity.handleInvalidApplicantCustomerDetails = function (entityName, formId, data) {
        var message = null;
        if (data && data.tooManyFailedAttempts === 'true') {
            message = 'Too many failed attempts, please try again in a few minutes.';
        } else {
            message = 'You have entered incorrect information. Please check for any mistakes and try again.';
        }

        cc_UI.showErrorDialog(message, 'Incorrect Information');
    };

    cip_Entity.onCleanAndRefresh = function (entityName, formId, application) {
        $("body").addClass(formId);
    };

    cip_Entity.onPreRendering = function (entityName, formId, application) {
        // $('#cloudcase-page-navigator').affix({offset: {top: 0}});
        var redirectToProgressScreen = function(){
            window.location.href = cip_Entity.clientHomePageUrl;
        };

        if(cc_Model.isInterviewComplete == true){
            if(cc_Config.applicationId){
                // application was just submitted in the previous request
                cc_UI.showNotificationDialog("Application has been submitted", "Application Submitted", redirectToProgressScreen);
            }else{
                cc_UI.showNotificationDialog("Application has already been submitted", "Application Previously Submitted", redirectToProgressScreen);
            }
        }

        $('.save-exit').on('click', function() {
            cc_Controller.save("SAVE");
        });

        if ($('.mobile-nav-overlay').length === 0) {
            $('#cloudcase-form').append(
                '<div class="mobile-nav-overlay">\n' +
                '<div class="mobile-nav-overlay__top-banner">\n' +
                '<div class="mobile-logo">' +
                '<svg width="225" height="30" viewBox="0 0 225 30" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M2.62613 25.4148C0.0758982 20.6226 -0.598804 16.3524 0.602021 12.6044C1.80285 8.85639 5.43496 5.61651 11.4984 2.88477C11.3504 5.84411 11.3504 7.93573 11.4984 9.15961C11.915 12.6044 12.1855 14.2229 11.915 16.7061C11.7245 18.4541 10.452 20.6857 7.76614 22.6819C6.86938 23.3484 5.15604 24.2593 2.62613 25.4148Z" fill="#CDCE00"></path>\n' +
                '<path d="M2.63097 25.4134C1.34477 22.5465 0.574199 20.4598 0.319265 19.1533C-0.158146 16.7066 -0.000888322 14.4589 0.667585 12.4052C0.899272 11.6935 1.32123 10.8626 1.93345 9.91269C4.07419 9.80415 5.67781 9.73504 6.74431 9.70538C7.8108 9.67572 9.41066 9.66133 11.5439 9.66214C11.9913 12.8 12.1245 15.1858 11.9437 16.8194C11.7527 18.5444 10.477 20.7466 7.78421 22.7164C6.88514 23.3741 5.1674 24.2731 2.63097 25.4134Z" fill="url(#paint0_linear)"></path>\n' +
                '<path d="M21.1142 28.2273C26.2068 23.7643 28.7543 19.2421 28.7565 14.6606C28.7587 10.0792 25.8241 5.30928 19.9526 0.350992C18.8721 3.76824 18.0984 5.88988 17.6315 6.71591C16.2227 9.208 14.4681 12.1858 13.8559 15.0302C13.425 17.0325 13.9545 20.3584 16.3336 23.5429C17.1279 24.6061 18.7214 26.1676 21.1142 28.2273Z" fill="url(#paint1_linear)"></path>\n' +
                '<path d="M7.58398 22.8565C10.375 22.6821 12.8028 22.1191 14.8977 21.1663C15.423 20.9274 13.398 18.6094 13.7623 15.6117C13.9596 13.9886 14.7252 12.2155 15.4267 10.788C16.2081 9.19799 16.9046 8.04953 16.8755 8.0579C14.5738 8.72134 13.0272 9.13859 11.5651 9.70262C11.565 9.70699 11.6503 10.0953 11.7105 10.8993C11.7707 11.7034 11.9126 12.9492 11.9653 14.1498C12.0236 15.4758 12.0974 16.8073 11.6466 18.0494C11.2245 19.2128 10.456 20.2327 9.75584 20.9792C8.61305 22.1976 7.58398 22.8565 7.58398 22.8565Z" fill="#C0D886"></path>\n' +
                '<path d="M14.8903 21.169C16.0176 20.6565 17.0545 20.0294 17.9938 19.2909C20.2613 17.5081 21.6517 15.5099 22.165 13.2964C21.0917 12.6401 20.1148 12.1014 19.2344 11.6805C18.3541 11.2596 17.1498 10.826 15.6215 10.3799C15.1903 11.2664 14.8935 11.9085 14.7311 12.3063C14.1504 13.7293 13.8414 14.8693 13.7352 15.6711C13.636 16.4196 13.7386 17.5904 13.9864 18.6446C14.3037 19.9946 14.8769 21.169 14.8903 21.169Z" fill="#70AB84"></path>\n' +
                '<path d="M3.91766 22.8771C5.17855 22.9368 6.4371 22.9285 7.58335 22.8569C7.59327 22.8569 8.25889 22.4089 9.04621 21.6876C9.25239 21.4987 9.46199 21.2876 9.67619 21.065C10.594 20.1112 11.5069 18.8201 11.8408 17.3626C11.9966 16.6823 12.0123 15.9668 12.0219 15.2826C12.0337 14.4409 11.9881 13.6192 11.9286 12.8745C11.8531 11.9292 11.7384 11.1114 11.6641 10.5423C11.5955 10.0167 11.5643 9.70303 11.5643 9.70303C10.8041 9.99816 10.0372 10.3449 9.2235 10.773C7.48946 11.6853 5.68708 13.7828 4.69345 17.0619C4.3617 18.1567 4.1031 20.0951 3.91766 22.8771Z" fill="#9DC15F"></path>\n' +
                '<path d="M22.1657 13.3103C22.5082 12.3863 22.9911 10.9546 23.2946 9.13461C23.4164 8.40403 23.5525 7.12614 23.7028 5.30094C20.6974 6.68729 18.5314 7.57232 17.2049 7.95604C17.1216 7.98014 17.0116 8.01377 16.875 8.05693C16.6363 8.48193 16.4544 8.8079 16.3291 9.03484C16.1612 9.33908 15.8824 9.86902 15.6272 10.3671C16.4758 10.6319 17.1105 10.8211 17.4793 10.9552C18.1106 11.1848 18.663 11.4255 19.1603 11.646C20.5603 12.2668 22.1657 13.3103 22.1657 13.3103Z" fill="#449869"></path>\n' +
                '<path d="M17.6907 26.8105C18.2067 27.3827 18.5991 27.7882 18.868 28.0272C19.1368 28.2662 19.5452 28.5725 20.0932 28.9462C19.673 29.1754 19.2646 29.3574 18.868 29.4922C18.4714 29.627 17.8455 29.7964 16.9902 30.0006L17.6907 26.8105Z" fill="#007890"></path>\n' +
                '<path d="M21.1129 28.2273C23.2635 26.0942 24.7736 24.468 25.643 23.3488C26.3407 22.4507 27.8701 19.4456 28.0826 18.9191C24.296 13.4603 17.1867 9.66406 10.3573 9.66406C7.47157 9.66406 4.55511 9.67873 1.86858 9.9318C0.801319 11.9548 -0.170008 13.4365 0.0251551 17.4266C0.220318 21.4167 2.62589 25.4152 2.62589 25.4152C2.62901 25.4152 3.49997 25.0637 5.12946 24.2289C5.59599 23.9899 6.42755 23.5325 7.62413 22.8566C9.31165 22.6924 10.5794 22.5111 11.4273 22.3127C12.2751 22.1143 13.427 21.7295 14.8827 21.1582C15.7608 22.6574 16.5825 23.8413 17.3479 24.7097C18.1133 25.5782 19.3683 26.7507 21.1129 28.2273Z" fill="url(#paint2_linear)" fill-opacity="0.71"></path>\n' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M161.8 5.55664V20.4874H163.137V5.55664H161.8ZM138.223 12.0413V10.9158H139.724V8.58994H141.072V10.9158H143.834V12.0413H141.072V17.8721C141.072 18.4723 141.189 18.9082 141.423 19.1797C141.657 19.4512 142.011 19.587 142.486 19.587C142.997 19.587 143.604 19.4119 144.305 19.0618V20.2194C143.662 20.5409 142.957 20.7017 142.19 20.7017C141.43 20.7017 140.827 20.4874 140.382 20.0586C139.943 19.6299 139.724 18.9475 139.724 18.0114V12.0413H138.223ZM111.621 17.8292C111.621 16.8931 112.038 16.1821 112.871 15.6962C113.703 15.2032 114.872 14.9567 116.377 14.9567H117.473V13.7884C117.473 13.181 117.291 12.7201 116.925 12.4057C116.56 12.0841 116.056 11.9234 115.413 11.9234C114.5 11.9234 113.543 12.1806 112.542 12.6951V11.441C113.477 10.948 114.485 10.7015 115.566 10.7015C117.736 10.7015 118.821 11.7018 118.821 13.7026V20.3159C117.988 20.5445 117.061 20.6588 116.038 20.6588C114.65 20.6588 113.565 20.4302 112.783 19.9729C112.009 19.5156 111.621 18.801 111.621 17.8292ZM113.912 16.4787C113.283 16.7716 112.969 17.2218 112.969 17.8292C112.969 18.4366 113.251 18.8796 113.813 19.1583C114.383 19.4298 115.15 19.5656 116.114 19.5656C116.553 19.5656 117.006 19.5227 117.473 19.437V16.0285H116.465C115.398 16.0285 114.547 16.1786 113.912 16.4787ZM121.241 17.3683V10.9158H122.589V17.304C122.589 18.8117 123.59 19.5656 125.592 19.5656C126.308 19.5656 127.027 19.5227 127.751 19.437V10.9158H129.099V20.3802C127.9 20.5945 126.764 20.7017 125.69 20.7017C124.229 20.7017 123.122 20.4373 122.37 19.9086C121.617 19.3798 121.241 18.533 121.241 17.3683ZM132.077 11.3767C131.515 11.8269 131.233 12.4629 131.233 13.2846C131.233 14.0349 131.423 14.6173 131.803 15.0317C132.183 15.4461 132.815 15.7998 133.699 16.0928C134.167 16.2429 134.517 16.3643 134.751 16.4572C134.985 16.5501 135.222 16.6752 135.463 16.8324C135.705 16.9824 135.873 17.1539 135.968 17.3469C136.063 17.5398 136.11 17.7756 136.11 18.0543C136.11 19.0761 135.434 19.587 134.083 19.587C133.104 19.587 132.183 19.2083 131.321 18.4509V19.9407C131.621 20.1694 132.019 20.3516 132.516 20.4874C133.012 20.6303 133.535 20.7017 134.083 20.7017C135.062 20.7017 135.862 20.4695 136.483 20.005C137.111 19.5406 137.425 18.8582 137.425 17.9578C137.425 17.5362 137.359 17.1682 137.228 16.8538C137.096 16.5394 136.895 16.275 136.625 16.0607C136.362 15.8391 136.07 15.6569 135.748 15.514C135.434 15.364 135.043 15.2211 134.576 15.0853C133.823 14.8566 133.294 14.6101 132.987 14.3457C132.687 14.0742 132.537 13.7205 132.537 13.2846C132.537 12.8344 132.698 12.4771 133.02 12.2128C133.341 11.9484 133.772 11.8162 134.313 11.8162C134.839 11.8162 135.306 11.9055 135.715 12.0841C136.132 12.2556 136.552 12.5093 136.976 12.8451V11.4196C136.274 10.9408 135.387 10.7015 134.313 10.7015C133.392 10.7015 132.647 10.9266 132.077 11.3767ZM146.111 11.7947V20.4874H147.448V12.5022C148.033 12.1735 148.767 12.0091 149.651 12.0091C150.308 12.0091 150.886 12.0913 151.382 12.2556V10.9587C150.82 10.8301 150.272 10.7658 149.738 10.7658C148.438 10.7658 147.229 11.1088 146.111 11.7947ZM151.95 17.8292C151.95 16.8931 152.366 16.1821 153.199 15.6962C154.032 15.2032 155.201 14.9567 156.706 14.9567H157.802V13.7884C157.802 13.181 157.619 12.7201 157.254 12.4057C156.889 12.0841 156.385 11.9234 155.742 11.9234C154.829 11.9234 153.871 12.1806 152.871 12.6951V11.441C153.806 10.948 154.814 10.7015 155.895 10.7015C158.065 10.7015 159.15 11.7018 159.15 13.7026V20.3159C158.317 20.5445 157.389 20.6588 156.366 20.6588C154.978 20.6588 153.893 20.4302 153.112 19.9729C152.337 19.5156 151.95 18.801 151.95 17.8292ZM154.24 16.4787C153.612 16.7716 153.298 17.2218 153.298 17.8292C153.298 18.4366 153.579 18.8796 154.142 19.1583C154.712 19.4298 155.479 19.5656 156.443 19.5656C156.881 19.5656 157.334 19.5227 157.802 19.437V16.0285H156.794C155.727 16.0285 154.876 16.1786 154.24 16.4787ZM165.611 7.93612C165.611 7.66459 165.71 7.43236 165.907 7.23943C166.112 7.03935 166.349 6.93931 166.62 6.93931C166.897 6.93931 167.135 7.03935 167.332 7.23943C167.529 7.43236 167.628 7.66459 167.628 7.93612C167.628 8.20051 167.529 8.43274 167.332 8.63282C167.135 8.82575 166.897 8.92221 166.62 8.92221C166.349 8.92221 166.112 8.82575 165.907 8.63282C165.71 8.43274 165.611 8.20051 165.611 7.93612ZM165.951 20.4874V10.9158H167.288V20.4874H165.951ZM170.563 15.6962C169.73 16.1821 169.313 16.8931 169.313 17.8292C169.313 18.801 169.7 19.5156 170.475 19.9729C171.257 20.4302 172.342 20.6588 173.73 20.6588C174.753 20.6588 175.68 20.5445 176.513 20.3159V13.7026C176.513 11.7018 175.428 10.7015 173.258 10.7015C172.177 10.7015 171.169 10.948 170.234 11.441V12.6951C171.235 12.1806 172.192 11.9234 173.105 11.9234C173.748 11.9234 174.252 12.0841 174.617 12.4057C174.983 12.7201 175.165 13.181 175.165 13.7884V14.9567H174.069C172.564 14.9567 171.395 15.2032 170.563 15.6962ZM170.661 17.8292C170.661 17.2218 170.975 16.7716 171.604 16.4787C172.239 16.1786 173.09 16.0285 174.157 16.0285H175.165V19.437C174.698 19.5227 174.245 19.5656 173.806 19.5656C172.842 19.5656 172.075 19.4298 171.505 19.1583C170.942 18.8796 170.661 18.4366 170.661 17.8292ZM110.202 5.56048H107.015L104.345 20.4873H107.532L110.202 5.56048ZM71.1765 10.6093H67.9895L66.2164 20.4873H69.4035L71.1765 10.6093ZM70.0543 9.4239C71.0194 9.4239 71.8723 8.63366 71.8723 7.64585C71.8723 6.63609 71.0194 5.84585 70.0543 5.84585C69.0444 5.84585 68.2139 6.63609 68.2139 7.64585C68.2139 8.63366 69.0444 9.4239 70.0543 9.4239ZM53.2613 17.3044C52.184 17.8093 51.1516 18.0947 49.8274 18.0947C48.6603 18.0947 47.6503 17.6337 47.4259 16.5581V16.4922H53.6877C53.9795 15.7678 54.1366 14.8898 54.1366 14.319C54.1366 12.0581 52.8124 10.3898 49.8723 10.3898C46.3486 10.3898 44.2837 12.9361 44.2837 16.0093C44.2837 19.1264 46.371 20.7069 49.3336 20.7069C50.7027 20.7069 51.7351 20.5312 52.7899 20.0483L53.2613 17.3044ZM47.5381 14.6922C47.8299 13.5946 48.5705 12.8703 49.7376 12.8703C50.6129 12.8703 51.1516 13.3971 51.1516 14.2312C51.1516 14.3849 51.1291 14.5385 51.1067 14.6922H47.5381ZM44.5504 10.741C43.7874 10.5215 43.2487 10.4337 42.3734 10.4337C41.0941 10.4337 39.1864 10.7849 38.0642 11.3337L36.4258 20.4873H39.6128L40.8697 13.5068C41.2512 13.419 41.8347 13.3751 42.3509 13.3751C43.114 13.3751 43.6527 13.4629 44.0342 13.6385L44.5504 10.741ZM58.7386 24.6581C57.3246 24.6581 55.7536 24.2849 54.8558 23.6264L55.3496 20.8825C56.3371 21.5849 57.4369 22.0459 58.7162 22.0459C60.0852 22.0459 60.781 21.4751 61.0054 20.3556L61.0503 20.1361C60.8034 20.2459 60.3546 20.3556 59.6139 20.3556C56.8982 20.3556 55.0129 18.841 55.0129 16.0093C55.0129 12.5629 57.3471 10.3898 61.1177 10.3898C63.1152 10.3898 64.7311 10.9166 65.786 11.5532L64.2149 20.2459C63.6089 23.6264 61.6563 24.6581 58.7386 24.6581ZM60.4668 17.7873C60.8034 17.7873 61.1177 17.7434 61.4992 17.6556L62.2847 13.3312C61.9256 13.1776 61.4992 13.0898 60.9157 13.0898C59.3446 13.0898 58.2673 14.0117 58.2673 15.7459C58.2673 16.9971 59.0079 17.7873 60.4668 17.7873ZM82.3691 15.1312C82.3691 18.2483 80.237 20.7069 76.6684 20.7069C73.5712 20.7069 71.6634 18.7093 71.6634 15.9654C71.6634 12.8483 73.7956 10.3898 77.3642 10.3898C80.4614 10.3898 82.3691 12.3873 82.3691 15.1312ZM74.828 15.8995C74.828 17.1946 75.5687 18.1166 76.7806 18.1166C78.217 18.1166 79.2046 16.8434 79.2046 15.219C79.2046 13.9239 78.4639 13.002 77.2519 13.002C75.8155 13.002 74.828 14.2751 74.828 15.8995ZM92.3836 20.4873L93.416 14.6922C93.4834 14.2532 93.5283 13.7922 93.5283 13.419C93.5283 11.1581 92.0021 10.3898 89.5108 10.3898C87.9173 10.3898 85.8749 10.8727 84.5956 11.3117L82.9572 20.4873H86.1442L87.4011 13.419C87.9173 13.2654 88.4784 13.1776 88.9946 13.1776C89.8475 13.1776 90.2739 13.5727 90.2739 14.2093C90.2739 14.319 90.2739 14.4727 90.229 14.7142L89.1966 20.4873H92.3836ZM98.9407 13.0239C98.0205 13.0239 96.7637 13.2434 95.9108 13.7044L96.3821 11.0702C97.3023 10.6312 98.6041 10.3898 99.816 10.3898C102.06 10.3898 103.564 11.2239 103.564 13.2873C103.564 13.6166 103.519 14.0337 103.452 14.4288L102.42 20.2239C101.32 20.4873 100.063 20.7069 98.6938 20.7069C96.0455 20.7069 94.2724 19.7849 94.2724 17.7654C94.2724 15.5044 96.225 14.5605 99.2101 14.5605H100.287L100.31 14.4727C100.355 14.2532 100.377 14.0776 100.377 13.9678C100.377 13.2873 99.9731 13.0239 98.9407 13.0239ZM99.5916 18.38L99.9507 16.4703H99.1876C98.0205 16.4703 97.4146 16.8434 97.4146 17.5678C97.4146 18.2044 97.9532 18.4678 98.6938 18.4678C98.9183 18.4678 99.2774 18.4459 99.5916 18.38ZM182.363 5.56048L179.826 19.7629C180.724 20.3556 182.722 20.7069 184.495 20.7069C188.422 20.7069 190.779 18.5117 190.779 14.9995C190.779 12.1678 188.894 10.3898 186.133 10.3898C185.527 10.3898 185.123 10.4776 184.652 10.6312L185.55 5.56048H182.363ZM184.158 13.3971C184.54 13.1776 184.966 13.0678 185.595 13.0678C186.784 13.0678 187.592 13.8581 187.592 15.1751C187.592 16.9971 186.403 18.0727 184.674 18.0727C184.068 18.0727 183.619 17.9849 183.35 17.8751L184.158 13.3971ZM192.974 13.7044C193.827 13.2434 195.084 13.0239 196.004 13.0239C197.037 13.0239 197.441 13.2873 197.441 13.9678C197.441 14.0776 197.418 14.2532 197.373 14.4727L197.351 14.5605H196.273C193.288 14.5605 191.336 15.5044 191.336 17.7654C191.336 19.7849 193.109 20.7069 195.757 20.7069C197.126 20.7069 198.383 20.4873 199.483 20.2239L200.515 14.4288C200.583 14.0337 200.628 13.6166 200.628 13.2873C200.628 11.2239 199.124 10.3898 196.879 10.3898C195.667 10.3898 194.366 10.6312 193.445 11.0702L192.974 13.7044ZM197.014 16.4703L196.655 18.38C196.341 18.4459 195.982 18.4678 195.757 18.4678C195.017 18.4678 194.478 18.2044 194.478 17.5678C194.478 16.8434 195.084 16.4703 196.251 16.4703H197.014ZM211.867 14.6922L210.834 20.4873H207.647L208.68 14.7142C208.725 14.4727 208.725 14.319 208.725 14.2093C208.725 13.5727 208.298 13.1776 207.445 13.1776C206.929 13.1776 206.368 13.2654 205.852 13.419L204.595 20.4873H201.408L203.046 11.3117C204.326 10.8727 206.368 10.3898 207.962 10.3898C210.453 10.3898 211.979 11.1581 211.979 13.419C211.979 13.7922 211.934 14.2532 211.867 14.6922ZM219.883 20.4873H223.317L220.466 15.241L225 10.6093H221.184L217.122 15.1312L219.883 20.4873ZM218.716 5.56048H215.529L212.858 20.4873H216.045L218.716 5.56048Z" fill="#015060"></path>\n' +
                '<defs>\n' +
                '<linearGradient id="paint0_linear" x1="5.74596" y1="13.8361" x2="4.72001" y2="21.7607" gradientUnits="userSpaceOnUse">\n' +
                '<stop stop-color="#D1D151"></stop>\n' +
                '<stop offset="1" stop-color="#CDCE00"></stop>\n' +
                '</linearGradient>\n' +
                '<linearGradient id="paint1_linear" x1="24.9334" y1="20.2964" x2="20.4542" y2="18.1444" gradientUnits="userSpaceOnUse">\n' +
                '<stop stop-color="#429CB2"></stop>\n' +
                '<stop offset="1" stop-color="#017991"></stop>\n' +
                '</linearGradient>\n' +
                '<linearGradient id="paint2_linear" x1="11.1561" y1="19.1981" x2="14.2809" y2="3.31648" gradientUnits="userSpaceOnUse">\n' +
                '<stop stop-color="white" stop-opacity="0"></stop>\n' +
                '<stop offset="1" stop-color="#EEEEEE"></stop>\n' +
                '</linearGradient>\n' +
                '</defs>\n' +
                '</svg>\n' +
                '</div>' +
                '<div class="mobile-nav-close">' +
                '<div>' +
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<rect x="1.63672" y="0.222656" width="20" height="2" rx="1" transform="rotate(45 1.63672 0.222656)" fill="#015060"></rect>' +
                '<rect x="0.222656" y="14.3652" width="20" height="2" rx="1" transform="rotate(-45 0.222656 14.3652)" fill="#015060"></rect>' +
                '</svg>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '<div id="cloudcase-page-navigator" class="mobile">' +
                '<ul id="cloudcase-page-navigator-unrestricted"></ul>' +
                '<ul id="cloudcase-page-navigator-restricted"></ul>' +
                '</div>' +
                '</div>'
            );
        }

        // Bind event listeners for new mobile nav
        $('.header-nav-toggle').on('click', function() {
            cip_Custom.showNavigationOverlay();
        });

        $('.mobile-nav-close').on('click', function() {
            cip_Custom.hideNavigationOverlay();
        });

        if ($('#cloudcase-save-mobile').length === 0) {
            $("#cloudcase-form").append('' +
                '<div id="cloudcase-save-mobile">' +
                '<svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M15.6819 23.5623L8.00006 17.1609L0.318237 23.5623V0.437622H15.6819V23.5623ZM8.00006 15.6228L14.5001 21.0397V1.61944H1.50006V21.0397L8.00006 15.6228Z" fill="white"/>\n' +
                '</svg>\n' +
                '</div>' +
                '<div id="cloudcase-save-overlay">' +
                '<div id="close-save-overlay">' +
                '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M13.0143 4.83222C12.7303 4.5482 12.2215 4.59657 11.8778 4.94025L9.0142 7.80384L6.1363 4.92594C5.79268 4.58232 5.28387 4.534 4.99986 4.81802C4.71584 5.10203 4.76416 5.61084 5.10778 5.95446L7.98569 8.83236L4.82821 11.9898C4.48453 12.3335 4.43617 12.8424 4.72019 13.1264C5.0042 13.4104 5.51305 13.362 5.85673 13.0184L9.0142 9.86088L12.0461 12.8928C12.3897 13.2364 12.8985 13.2847 13.1825 13.0007C13.4665 12.7167 13.4182 12.2079 13.0746 11.8642L10.0427 8.83236L12.9063 5.96876C13.25 5.62509 13.2984 5.11624 13.0143 4.83222Z" fill="#015060"/>\n' +
                '</svg>\n' +
                '</div>' +
                '<button class="btn btn-default save-exit-mobile" id="save-exit-mobile">Save & Exit</button>' +
                '<a class="btn btn-default save-exit-mobile" href="tel:132067" id="save-exit-mobile">Call us</a>' +
                '</div>'
            );
        }

        // Bind event listeners for mobile continue / save
        $('body').on('click', '#cloudcase-save-mobile', function() {
            cip_Custom.removeBodyScroll();
            $('#cloudcase-save-overlay').addClass('active');
        });

        $('body').on('click','#close-save-overlay', function() {
            cip_Custom.restoreBodyScroll();
            $('#cloudcase-save-overlay').removeClass('active');
        });

        $('body').on('click','#save-exit-mobile', function() {
            cip_Custom.restoreBodyScroll();
            $('#cloudcase-save-overlay').removeClass('active');
            cc_Controller.save("SAVE");
        });
    };

    cip_Entity.onPostRendering = function (entityName, formId, application) {
        $('.page_navigator_item a:contains(\()').not('[data-post-rendered]').html(function () {
            return $(this).attr('data-post-rendered', 'true').html().replace("(", "<br>(");
        });
    };

    cip_Entity.onPreFindingsAssessment = function (entityName, formId, application, continuation) {
        cc_UI.showConfirmDialog('Would you like to submit application?', function () {
            continuation();
        }, null, 'Application Complete');
    };

    cip_Entity.onPostFindingsAssessment = function (entityName, formId, application) {
        var message = null;
        if (application.stageId === 'Accepted') {
            message = 'Your application has been accepted.';

        } else if (application.stageId === 'ConditionalApproval') {
            message = 'Your application has been conditionally approved.';

        } else {
            message = 'Your application has been submitted and one of our friendly staff members will be in touch shortly.';
        }

        cip_Entity.hasSubmitted = true;

        cc_UI.showNotificationDialog(message, "Application Submitted", function () {
            window.location.href = cip_Entity.clientHomePageUrl;
        });
    };

    cip_Entity.onPostFindingsReassessment = function (entityName, formId, application) {
    };

    cip_Entity.onPreGetQuestions = function (entityName, formId, application, task) {
    };

    cip_Entity.onPostChangedEnteredValue = function (entityName, formId, application, question, updatedEnteredValue) {
    };

    cip_Entity.onPostShowPage = function (entityName, formId, application, page) {
        // cip_Custom.addCollapsibleNavigation();
        // cip_Custom.addPaginatedNavigation();
        // cip_Custom.showMore();
        cip_Custom.renderTabBarContents();

        if(cip_Entity.previousSelectedPageId != page.id){
            if(ga){
                ga('send', {
                    hitType: 'pageview',
                    page: '/virtual/' + cc_Config.rulebookName + '/' + page.id
                });
            }


            cip_Entity.previousSelectedPageId = page.id;
        }
    };

    cip_Entity.init = function () {
        // load google analytics
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

        ga('create', 'UA-68616821-1', 'auto');
        ga('send', 'pageview');

        // load google tag manager
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-M66MVHZ');

        // load microsoft clarity
        (function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i+"?ref=gtm2";
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window,document,"clarity","script","kxr73xfxm4");

        if(window.addEventListener){
            window.addEventListener('beforeunload', function() {
                if (cip_Entity.hasSubmitted == false && cc_Config.applicationId && cc_Config.rulebookName && cc_Model.selectedPage && dataLayer) {
                    dataLayer.push({
                        'event' : 'Form.Interaction',
                        'eventCategory': cc_Config.rulebookName,
                        'eventAction' : 'Abandonment',
                        'eventLabel' : cc_Model.selectedPage.id
                    });
                }
            });
        }
        cc_UI.initViewpoint = function () {
            $("[name=viewport]").attr("content", "width=device-width, initial-scale=1.0, minimum-scale=1.0, viewport-fit=cover");
        };

        cc_UI.initViewpoint();
        cc_UI.initViewpoint = function(){
            $("[name=viewport]").attr("content", "width=device-width, initial-scale=1.0, minimum-scale=1.0, viewport-fit=cover");
        };

        cc_UI.initViewpoint();
    };
})();